export default __webpack_public_path__ + "static/media/think-different.881a31b3.jpg";